import { render, staticRenderFns } from "./EditOrganisation.vue?vue&type=template&id=d547d760"
import script from "./EditOrganisation.vue?vue&type=script&lang=js"
export * from "./EditOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports